import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import { Prompt } from 'react-router';
import Button from '../../../common/base/Button';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import { Div, StyledUtilsProps } from '../../../common/helpers/StyledUtils';
const SaveButton: React.FC<Pick<StyledUtilsProps, 'm'>> = t0 => {
  const $ = _c(18);
  const {
    m
  } = t0;
  const {
    isSubmitting,
    dirty,
    touched,
    initialValues,
    values
  } = useFormikContext();
  let t1;
  if ($[0] !== dirty || $[1] !== initialValues || $[2] !== touched || $[3] !== values) {
    t1 = dirty && Object.keys(touched).some(k => initialValues[k] != values[k]);
    $[0] = dirty;
    $[1] = initialValues;
    $[2] = touched;
    $[3] = values;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const has_changes = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: 4,
      align: "center"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = has_changes && !isSubmitting;
  let t4;
  if ($[6] !== t3) {
    t4 = <Prompt when={t3} message={_temp} />;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isSubmitting || !has_changes;
  const t6 = isSubmitting ? "loading" : "save";
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Button.Permission primary={true} disabled={t5} submit={true} icon={t6}>Save</Button.Permission>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== has_changes) {
    t8 = has_changes && <Text muted={true} size="m"><Icon icon="info" left={true} />You have unsaved changes</Text>;
    $[11] = has_changes;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== m || $[14] !== t4 || $[15] !== t7 || $[16] !== t8) {
    t9 = <Div m={m} flex={t2}>{t4}{t7}{t8}</Div>;
    $[13] = m;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};
export default SaveButton;
function _temp(location) {
  return location.pathname != window.location.pathname ? "Are you sure you want to quit without saving your work?" : true;
}